import { Navigate, useLocation } from 'react-router-dom';
import { journeyRedirectHref, STUDY_HOME_PATH } from './studyYearRoutes';

/** Old `/learn/study/year` links (any tab) open My journey with the same year, Term and hash. */
export function StudyYearRedirect() {
  const { search, hash } = useLocation();
  return <Navigate replace to={journeyRedirectHref(search, hash)} />;
}

/** Old `/learn/study/plan` links open Study Home, where the tasks now live. */
export function StudyPlanRedirect() {
  return <Navigate replace to={STUDY_HOME_PATH} />;
}
